import {SHOW_TOAST_MESSAGE_LOCAL} from "./types";
export const showToastMessage = (toastOptions) => dispatch => {
     dispatch({
        type: SHOW_TOAST_MESSAGE_LOCAL,
        payload: toastOptions
     });
};

export const showMessage = payload => ({
	type: "SHOW_TOAST_MESSAGE_LOCAL",
	payload
});
export const hideMessage = payload => ({
	type: "HIDE_TOAST_MESSAGE_LOCAL",
	payload
});
